import { create } from "zustand";

/**
 * Режим панели накопления: весь рынок или только наши контрагенты.
 *
 * Стор, а не useState в панели, по той же причине, что у окна статистики
 * (store/useFlowWindow.ts): панель живёт на странице рынка, рынки пятиминутные, и
 * оператор переходит с окна на окно десятки раз за сессию. Локальное состояние
 * сбрасывалось бы на «весь рынок» при каждом переходе — то есть режим, ради
 * которого экран и открыт, приходилось бы включать заново на каждом новом окне.
 *
 * Без записи в localStorage, и это осознанно: режим «против нас» показывает
 * подмножество рынка, и вкладка, открытая на нём после перезагрузки, выглядела бы
 * рынком из трёх кошельков. Умолчание — весь рынок, то есть то же, что видит
 * сервер без параметра.
 */
interface AgainstUsStore {
  /** Показывать только тех, с кем мы в этом рынке торговали. */
  against: boolean;
  set: (against: boolean) => void;
}

export const useAgainstUs = create<AgainstUsStore>((set) => ({
  against: false,
  set: (against) => set({ against }),
}));
